module.exports = __webpack_public_path__ + "img/BfA_bie.16243881.png";